import Field, { InputFieldProps } from "./Field";

export interface TextFieldProps extends Omit<InputFieldProps, "controlType"> {
  type: "text" | "email";
}

export default function TextField(props: TextFieldProps) {
  return <Field controlType="input" {...props} />;
}
